<template>
  <TagSelector
    :multiple="multiple"
    :items="customComponents"
    :value="value"
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  props: {
    value: [String, Number, Array],
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      customComponents: [],
    };
  },
  created() {
    this.setCustomComponents();
  },
  methods: {
    async setCustomComponents() {
      const { data } = await this.$api.CustomComponent.lite();
      this.customComponents = data;
    },
  },
};
</script>

<style></style>
